/**
 * The FM's own scope in the top bar (FM Manager R1 A11): "All sites" when the
 * account is not limited, else "My sites (n)". Shown to the two FM roles only,
 * and small enough to sit beside the bell at 360 px.
 */
import { Link } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { isSiteScopedRole } from '@/components/Admin/SiteScopeField';

export default function SiteScopeChip() {
  const user = useAuthStore((s) => s.user);
  if (!user || !isSiteScopedRole(user.role)) return null;
  const n = (user.site_ids ?? []).length;
  // FM Technician C2: an empty list is "no site" for a technician — the
  // server's site_scope says which, never the length alone.
  if (user.site_scope?.mode === 'none') {
    return (
      <Link to="/tech/no-site" data-testid="site-scope-chip"
            className="inline-flex shrink-0 items-center whitespace-nowrap rounded-full bg-warning-50 px-2 py-0.5 text-[10px] font-semibold text-warning-800">
        No site yet
      </Link>
    );
  }
  return (
    <Link
      to="/settings"
      data-testid="site-scope-chip"
      title={n === 0 ? 'You can see every site' : 'Limited to your sites. See Settings.'}
      className={`inline-flex shrink-0 items-center whitespace-nowrap rounded-full px-2 py-0.5 text-[10px] font-semibold ${
        n === 0 ? 'bg-brand-50 text-brand-700' : 'bg-surface-muted text-content-secondary'}`}
    >
      {n === 0 ? 'All sites' : `My sites (${n})`}
    </Link>
  );
}
